/**
 * P8-1: `config.audio.successSE / failSE / tapSE` の「静かな契約違反」解消。
 *
 * minigameConfig（凍結スキーマ）には作者向けの SE 指定が最初から存在するのに、
 * テンプレ側の呼び出しが 0 件で「Studio で指定しても鳴らない」状態だった。
 * R2 の 1 点配線戦略と同じく、semantic 層（useMountSound / AdvanceTrigger）に
 * 「アセット SE があればそれを優先・無ければ従来の合成音」の分岐を 1 箇所ずつ置き、
 * 19 テンプレへ無改修で波及させる。
 *
 * 仕組み:
 *  - MinigameHost がマウント中のミニゲーム step の config.audio を解決してここへ登録する
 *    （unmount で解除）。ミニゲームは同時に 1 つしか動かないためシングルトンで足りる。
 *  - semantic 側は発火の瞬間に getActiveMinigameSeUrl() を読む。未登録（Sandbox 直マウント等）
 *    なら undefined → 従来の合成 SFX にフォールバック（挙動不変）。
 *  - 再生は audioEngine.playSfxAsset()（master mute/volume 連動・失敗安全）。
 *
 * 対応表（正本: docs/prod/specs/minigame-config-spec.md）:
 *  - successSE → JudgementModal の成功表示（useMountSound 'success'）
 *  - failSE    → FailOverlay の表示（useMountSound 'fail'）
 *  - tapSE     → AdvanceTrigger の確定タップ（従来 select 音の箇所）
 */

export interface MinigameSeUrls {
  success?: string;
  fail?: string;
  tap?: string;
}

let active: MinigameSeUrls | null = null;

/** MinigameHost 専用: マウント中ミニゲームの SE URL 群を登録/解除する。 */
export function setActiveMinigameSe(se: MinigameSeUrls | null): void {
  active = se;
}

/** semantic 層専用: 発火の瞬間に「いま優先すべきアセット SE」を読む（無ければ undefined）。 */
export function getActiveMinigameSeUrl(kind: keyof MinigameSeUrls): string | undefined {
  const url = active?.[kind];
  return typeof url === 'string' && url.trim() ? url : undefined;
}
